import { render } from "./ownerManager.vue?vue&type=template&id=68484c22&scoped=true&ts=true"
import script from "./ownerManager.vue?vue&type=script&lang=ts"
export * from "./ownerManager.vue?vue&type=script&lang=ts"

import "./ownerManager.vue?vue&type=style&index=0&id=68484c22&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68484c22"]])

export default __exports__